import React from 'react'
import { useDispatch } from 'react-redux'
import { toggleBatchPackingsView, addVarBatchPackings, updateVarBatchPackings } from '../var/varSlice'
import { Grid, Button } from '@material-ui/core'
import Input from '../../components/abstractObjects/Input'
import { BasicLabel } from '../../components/abstractObjects/Label'
import { Date, MonthYear } from '../../components/abstractObjects/Date'


export const BatchPackingsForm = ({ varId, varBatchPackingsFormId, BatchNumber, setBatchNumber, Quantity, setQuantity, ExpiryDate, setExpiryDate, cleanObj }) => {
    const dispatch = useDispatch()
    const backToList = () => {
        dispatch(
            toggleBatchPackingsView({ VarBatchPackingsFormId: null })
        )
    }
    const validateForm = () => {
        var validation = true
        if (!BatchNumber.value) {
            setBatchNumber({ error: "Required!" })
            validation = false
        }
        if (!Quantity.value) {
            setQuantity({ error: "Required!" })
            validation = false
        }
        if (!ExpiryDate.value) {
            setExpiryDate({ error: "Required!" })
            validation = false
        }

        return validation
    }

    const addObj = () => {
        dispatch(
            addVarBatchPackings({
                Id: (Math.random() * 16).toString().substring(10),
                VarTransactionId: varId,
                BatchNumber: BatchNumber.value,
                Quantity: parseInt(Quantity.value),
                ExpiryDate: ExpiryDate.value,
            })
        )
    }

    const updateObj = () => {
        dispatch(
            updateVarBatchPackings({
                VarTransactionId: varId,
                Id: varBatchPackingsFormId,
                BatchNumber: BatchNumber.value,
                Quantity: parseInt(Quantity.value),
                ExpiryDate: ExpiryDate.value,
            })
        )
    }

    const saveObj = (obj) => {
        if (!validateForm()) return false
        if (varBatchPackingsFormId != null) {
            updateObj()
        }
        else {
            addObj()
        }
        backToList()
        return true
    }

    const saveAndContinueObj = (obj) => {
        if (!validateForm()) return false
        if (varBatchPackingsFormId != null) {
            updateObj()
        }
        else {
            addObj()
        }
        cleanObj();
        return true
    }
    return [backToList, validateForm, saveObj, saveAndContinueObj];
}

export const BatchPackingsUI = (props) => {
    let backToList = props.backToList
    let batchPackings = props.VarBatchPackingsData
    let validateForm = props.validateForm
    let saveObj = props.saveObj
    let saveAndContinueObj = props.saveAndContinueObj
    return (
        <div>
            <Grid container>
                <Grid item xs={3} style={{ marginBottom: "0.75em" }}>
                    <Button color="primary" onClick={backToList} style={{ fontSize: "1.7rem", padding: "auto" }}><i className="fas fa-arrow-left"></i></Button>
                </Grid>
                <Grid item xs={9} style={{ marginBottom: "0.75em" }}>
                    <h4>Unicef VAR</h4>
                </Grid>
            </Grid>
            <Grid container justifyContent="space-evenly">
                <Grid item xs={12} sm={6}><BasicLabel text="BATCH_NUMBER" />*</Grid>
                <Grid item xs={12} sm={6}>
                    <Input value={batchPackings.BatchNumber.value} onChange={batchPackings.onBatchNumberChanged} error={batchPackings.BatchNumber.error} />
                </Grid>
                <Grid item xs={12} sm={6}><BasicLabel text="QUANTITY" />*</Grid>
                <Grid item xs={12} sm={6}>
                    <Input value={batchPackings.Quantity.value} onChange={batchPackings.onQuantityChanged} error={batchPackings.Quantity.error} onKeyDown={(e) => (e.keyCode >= 46 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 8 ? true : e.preventDefault()} />
                </Grid>
                <Grid item xs={12} sm={6}><BasicLabel text="EXPIRY_DATE" />*</Grid>
                <Grid item xs={12} sm={6}>
                    <MonthYear value={batchPackings.ExpiryDate.value} error={batchPackings.ExpiryDate.error} onChange={batchPackings.onExpiryDateChanged} />
                </Grid>
                <br /><br /><br />
                <Button onClick={saveObj} disabled={!validateForm} style={{ fontSize: "1rem", backgroundColor: "#ffc107", borderColor: "#ffc107", width: "45%", marginRight: "10%", padding: 2, color: "white", fontWeight: "bold" }}>
                    <BasicLabel text="SAVE" />
                </Button>
                <Button onClick={saveAndContinueObj} disabled={!validateForm} style={{ fontSize: "1rem", backgroundColor: "#ffc107", borderColor: "#ffc107", width: "45%", padding: 2, color: "white", fontWeight: "bold" }}>
                    <BasicLabel text="SAVE_AND_CONTINUE" />
                </Button>
            </Grid>
            <br />
        </div>
    )
}

export default BatchPackingsForm;